module.exports = __webpack_public_path__ + "img/Dantam Fashion 02.b67ff89b.jpg";